import { logIn, authorizeWithSoc, resetPassword as resetPasswordSendRequest} from '../../../logic/api.js';
import {setAuthToken, setUserId} from '../../../logic/authHelpers';
import {loginToVK as signInToVk} from '../../../logic/auth/vk';
import {loginToFb as signInToFb} from '../../../logic/auth/fb';
import initialState from '../../../redux/initialState';

export function openSignInPopup() {
  return {
    type: 'SIGNIN:POPUP-OPEN'
  };
}

export function closeSignInPopup() {
  return {
    type: 'SIGNIN:POPUP-CLOSE'
  };
}

export function signIn(creds) {
  return (dispatch) => {
    dispatch({
      type: 'SIGNIN:LOGIN-REQUEST-SENT'
    });
    return logIn(creds)
    .then((res) => {
      if (res.error) {
        return dispatch(onSignInFail(res.error));
      }
      dispatch(onSignInSuccess(res)); // TODO: need get User PartnerID here!
    })
    // .catch((err) => dispatch(onSignInSuccess(err)));
    .catch((err) => dispatch(onSignInFail(err)));
  };
}

const onSignInFail = (err) => ({
  type: 'SIGNIN:LOGIN-REQUEST-SENT-FAIL',
  err
});

const onSignInSuccess = ({access_token, userId, userData}) => {
  setAuthToken(access_token);
  setUserId(userId);
  // TODO: need set user partnerId to localstorage here
  return {
    type: 'SIGNIN:LOGIN-REQUEST-SENT-SUCCESS',
    access_token,
    userId,
    userData
  };
};

export const loginToVk = () => (dispatch) => {
  dispatch({
    type: 'SIGNIN:LOGIN-VK-REQUEST-SENT'
  });
  signInToVk()
  .then((code) =>
    authorizeWithSoc({
      code,
      type: 'VK'
    }))
  .then((res) => {
    if (res.error) {
      //todo remove it
      alert(res.error);
      return dispatch(onLoginWithVKFail(res.error));
    }
    dispatch(onLoginWithVKSuccess(res));
  })
  .catch((err) => dispatch(onLoginWithVKFail(err)));
};

const onLoginWithVKSuccess = ({access_token, userId, userData}) => (dispatch) => {
  setAuthToken(access_token);
  setUserId(userId);
  dispatch({
    type: 'SIGNIN:LOGIN-VK-REQUEST-SENT-SUCCESS',
    access_token,
    userId,
    userData
  });
  dispatch(closeSignInPopup());
};

const onLoginWithVKFail = (err) => {
  return {
    type: 'SIGNIN:LOGIN-VK-REQUEST-SENT-FAIL',
    err
  };
};

export const loginToFb = () => (dispatch) => {
  dispatch({
    type: 'SIGNIN:LOGIN-FB-REQUEST-SENT'
  });
  signInToFb()
  .then((code) =>
    authorizeWithSoc({
      code,
      type: 'FB'
    }))
  .then((res) => {
    if (res.error) {
      //todo remove it
      alert(res.error);
      return dispatch(onLoginToFBFail(res.error));
    }
    dispatch(onLoginToFBSuccess(res));
  })
  .catch((err) => dispatch(onLoginToFBFail(err)));
};

const onLoginToFBSuccess = ({access_token, userId, userData}) => (dispatch) => {
  setAuthToken(access_token);
  setUserId(userId);
  dispatch({
    type: 'SIGNIN:LOGIN-FB-REQUEST-SENT-SUCCESS',
    access_token,
    userId,
    userData
  });
  dispatch(closeSignInPopup());
};

const onLoginToFBFail = (err) => {
  return {
    type: 'SIGNIN:LOGIN-FB-REQUEST-SENT-FAIL',
    err
  };
};

export const switchToPasswordResetting = () => ({
  type: 'SIGNIN:SWITCH-TO-PASSWORD-RESETTING'
});

export const cancelPasswordResetting = (e) => {
  e.preventDefault();
  e.stopPropagation();
  return {
    type: 'SIGNIN:CANCEL-PASSWORD-RESETTING'
  };
};

export const resetPassword = (phone) => (dispatch) => {
  dispatch({
    type: 'SIGNIN:RESET-PASSWORD-REQUEST-SENT'
  });
  return resetPasswordSendRequest(phone)
  .then((res) => {
    if (res.error) {
      return dispatch(onResetPasswordFail(res.error));
    }
    dispatch({
      type: 'SIGNIN:RESET-PASSWORD-REQUEST-SENT-SUCCESS'
    });
  })
  .catch((err) => dispatch(onResetPasswordFail(err)));
};

const onResetPasswordFail = (err) => ({
  type: 'SIGNIN:RESET-PASSWORD-REQUEST-SENT-FAIL',
  err
});

export const resetErrors = () => ({
  type: 'SIGNIN:RESET-ERRORS'
});

export default
function signInPopupReducer(state = initialState.signInPopupState, action) {
  switch (action.type) {
    case 'SIGNIN:POPUP-OPEN':
      return {
        ...state,
        isOpen: true
      };

    case 'SIGNIN:POPUP-CLOSE':
      return {
        ...state,
        isOpen: false,
        loginErr: '',
        resetPasswordErr: ''
      };

    case 'SIGNIN:LOGIN-REQUEST-SENT-SUCCESS':
      return initialState.signInPopupState;

    case 'SIGNIN:LOGIN-REQUEST-SENT-ERROR':
      return {
        ...state,
        loginErr: ''
      };

    case 'SIGNIN:LOGIN-REQUEST-SENT-FAIL':
      return {
        ...state,
        loginErr: action.err
      };

    case 'SIGNIN:SWITCH-TO-PASSWORD-RESETTING':
      return {
        ...state,
        isResettingPassword: true
      };

    case 'SIGNIN:CANCEL-PASSWORD-RESETTING':
      return {
        ...state,
        isResettingPassword: false
      };

    case 'SIGNIN:RESET-PASSWORD-REQUEST-SENT-SUCCESS':
      return {
        ...state,
        isResettingPassword: false,
        resetPasswordErr: ''
      };

    case 'SIGNIN:RESET-PASSWORD-REQUEST-SENT-FAIL':
      return {
        ...state,
        resetPasswordErr: action.err
      };

    case 'SIGNIN:LOGIN-VK-REQUEST-SENT-FAIL':
      return {
        ...state,
        vkErr: action.err
      };

    case 'SIGNIN:LOGIN-FB-REQUEST-SENT-FAIL':
      return {
        ...state,
        fbErr: action.err
      };

    case 'SIGNIN:LOGIN-FB-REQUEST-SENT-SUCCESS':
      return {
        ...state,
        fbErr: ''
      };

    case 'SIGNIN:LOGIN-VK-REQUEST-SENT-SUCCESS':
      return {
        ...state,
        vkErr: ''
      };

    case 'SIGNIN:RESET-ERRORS':
      return {
        ...state,
        loginErr: '',
        resetPasswordErr: ''
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SignInPopup/redux/signInPopupActions.js
 **/